export default "__VITE_ASSET__1zPgzp5w__"